import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { NgModule, ErrorHandler } from '@angular/core';
import { Network } from '@ionic-native/network';

import { FCM } from '@ionic-native/fcm';


import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';

import { InAppBrowser } from '@ionic-native/in-app-browser';
import { SplashScreen } from '@ionic-native/splash-screen';

import { IonicStorageModule } from '@ionic/storage';
import { Geolocation } from '@ionic-native/geolocation';
import { ConferenceApp } from './app.component';

import { AboutPage } from '../pages/about/about';
import { HomePage } from '../pages/home/home';
import { TestPage } from '../pages/test/test';
import { PopoverPage } from '../pages/about-popover/about-popover';
import { AccountPage } from '../pages/account/account';
import { AccountTabsPage } from '../pages/account/tabs/tabs';
import { AccountCompletePage } from "../pages/account/complete/complete";
import { IdentityPage } from '../pages/account/identity/identity';
import { AddressPage } from '../pages/account/address/address';
import { CivilityPage } from '../pages/account/civility/civility';
import { CvPage } from '../pages/account/cv/cv';
import { DocumentsPage } from '../pages/account/documents/documents';
import { CvAddForm } from '../pages/account/cv/form/cvform';
import { SelfRankingPage } from '../pages/account/self-ranking/self-ranking';
import { RankingPage } from '../pages/account/ranking/ranking';
import { JobSelectForm } from '../pages/utils/job-select/job-select';
import { LocationSelectForm } from '../pages/utils/location-select/location-select';
import { DocumentSelectForm } from '../pages/utils/document-select/document-select';
import { DocumentViewer } from '../pages/utils/document-viewer/document-viewer';
import { LocationViewer } from '../pages/utils/location-viewer/location-viewer';
import { VideoRecorderForm } from '../pages/utils/video-recorder/video-recorder';
import { VideoWizardForm } from '../pages/utils/video-wizard/video-wizard';
import { Signpad } from '../pages/utils/signpad/signpad';
import { LoginPage } from '../pages/login/login';
import { NotificationsPage } from '../pages/account/notifications/notifications';
import { MessagingPage } from '../pages/account/messaging/messaging';
import { NotificationsPopover } from '../pages/account/notifications/popover';
import { MessagingPopover } from '../pages/support/popover';
import { MissionCandidateDetailPopover } from '../pages/missions/missions-candidate/missions-candidate-detail/popover';
import { MissionsListPage } from '../pages/missions/missions-list/missions-list';
import { MissionsMapPage } from '../pages/missions/missions-map/missions-map';
import { MissionDetailPage } from '../pages/missions/mission-detail/mission-detail';
import { MissionsFilterPage } from '../pages/missions/missions-filter/missions-filter';
import { MissionsFilterFormPage } from '../pages/missions/missions-filter/missions-filter-form/missions-filter-form';
import { MissionsPostulatePage } from '../pages/missions/missions-postulate/missions-postulate';
import { MissionsSignPage } from '../pages/missions/missions-sign/missions-sign';
import { MissionsTabsPage } from '../pages/missions/missions-candidate/tabs/tabs';

import { MissionsCandidatePage } from '../pages/missions/missions-candidate/mission-candidate-list/missions-candidate';
import { MissionsCandidateDetailPage } from '../pages/missions/missions-candidate/missions-candidate-detail/missions-candidate-detail';
import { MissionsContractListPage } from '../pages/missions/missions-contract/missions-contract-list/missions-contract-list';
import { MissionsCalendarPage } from '../pages/missions/missions-candidate/missions-calendar/missions-calendar';

import { MapPage } from '../pages/map/map';

import { SchedulePage } from '../pages/schedule/schedule';
import { ScheduleFilterPage } from '../pages/schedule-filter/schedule-filter';
import { SessionDetailPage } from '../pages/session-detail/session-detail';
import { SignupPage } from '../pages/signup/signup';
import { SpeakerDetailPage } from '../pages/speaker-detail/speaker-detail';
import { SpeakerListPage } from '../pages/speaker-list/speaker-list';
import { TabsPage } from '../pages/tabs-page/tabs-page';
import { TutorialPage } from '../pages/tutorial/tutorial';
import { SupportPage } from '../pages/support/support';

import { FormsModule } from "@angular/forms";


import { ConferenceData } from '../providers/conference-data';
import { MissionsData } from '../providers/missions-data';
import { UserData } from '../providers/user-data';
import { UiData } from '../providers/ui-data';
import { JobDataService } from '../providers/job-data';
import { PortalDataService } from '../providers/portal-data';

import { UploadService } from '../services/upload-service';

import { SearchPipe } from '../pipes/search/search';
import { SortPipe } from '../pipes/sort/sort';

import { Camera } from '@ionic-native/camera';
import { MediaCapture } from '@ionic-native/media-capture';

import { Device } from '@ionic-native/device';
import { AppVersion } from '@ionic-native/app-version';
import { Badge } from '@ionic-native/badge';

import { ProgressBarComponent } from '../components/progress-bar/progress-bar';
import { SignaturePadModule } from 'angular2-signaturepad';
import { Calendar } from '../components/calendar/calendar';

import { CompanyAccessModal} from "../pages/utils/company-access/company-access";
// Import the AF2 Module
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import {StatusBar} from '@ionic-native/status-bar';

import { ConnectivityService } from '../services/connectivity';
import { AuthService } from '../services/auth';
import { LogService } from '../services/logger';

import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { File } from '@ionic-native/file';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer';

import { ENV } from "@app/environment"


// AF2 Settings
export const firebaseConfig = ENV.FIREBASE_CONFIG;

import {enableProdMode} from '@angular/core';
import {FaIconComponent} from "../components/fa-icon/fa-icon.component";
import {Timesheet} from "../pages/utils/timesheet/timesheet";
import {AccountSettingsPage} from "../pages/account/settings/settings";
import {CvExperiencesPage} from "../pages/account/cv/experiences/experiences";
import {CvDiplomasPage} from "../pages/account/cv/diplomas/diplomas";
import {CvCertificatesPage} from "../pages/account/cv/certificates/certificates";
import {CvLanguagesPage} from "../pages/account/cv/languages/languages";
import {CvTabsPage} from "../pages/account/cv/tabs/tabs";
import {SwitchPage} from "../pages/switch/switch";
import {AvailabilityPage} from "../pages/account/availability/availability";
import {ContractsPage} from "../pages/account/contracts/contracts";
import {SalariesPage} from "../pages/account/salaries/salaries";
import {RibSelect} from "../pages/utils/rib-select/rib-select";

import { BrMaskerModule } from 'brmasker-ionic-3';
import {DocumentsCompleteModal} from "../pages/utils/documents-complete/documents-complete";
import { DatePickerModule } from 'ion-datepicker';

enableProdMode();

@NgModule({
    declarations: [
        FaIconComponent,
        Calendar,
        ConferenceApp,
        AboutPage,
        HomePage,
        TestPage,
        AccountPage,
        AccountCompletePage,
        AccountTabsPage,
        AccountSettingsPage,
        NotificationsPage,
        NotificationsPopover,
        MessagingPage,
        MessagingPopover,
        MissionCandidateDetailPopover,
        IdentityPage,
        AddressPage,
        CivilityPage,
        CvPage,
        CvExperiencesPage,
        CvDiplomasPage,
        CvCertificatesPage,
        CvLanguagesPage,
        CvTabsPage,
        CvAddForm,
        DocumentsPage,
        ContractsPage,
        SalariesPage,
        SelfRankingPage,
        RankingPage,
        JobSelectForm,
        LocationSelectForm,
        LocationViewer,
        DocumentSelectForm,
        DocumentViewer,
        VideoRecorderForm,
        VideoWizardForm,
        Signpad,
        Timesheet,
        SearchPipe,
        SortPipe,
        LoginPage,
        MissionsListPage,
        MissionsMapPage,
        MissionDetailPage,
        MissionsFilterPage,
        MissionsFilterFormPage,
        MissionsPostulatePage,
        MissionsSignPage,
        MissionsCandidatePage,
        MissionsCandidateDetailPage,
        MissionsContractListPage,
        MissionsCalendarPage,
        MissionsTabsPage,
        MapPage,
        PopoverPage,
        SchedulePage,
        ScheduleFilterPage,
        SessionDetailPage,
        SignupPage,
        SpeakerDetailPage,
        SpeakerListPage,
        TabsPage,
        TutorialPage,
        SupportPage,
        ProgressBarComponent,
        SwitchPage,
        AvailabilityPage,
        RibSelect,
        CompanyAccessModal,
        DocumentsCompleteModal

    ],
    imports: [
        BrowserModule,
        FormsModule,
        HttpModule,
        HttpClientModule,
        IonicModule.forRoot(ConferenceApp, {
            menuType: 'overlay',
            tabsHideOnSubPages:"true",
            platforms: {
                ios: {
                    menuType: 'overlay',
                    backButtonText: 'Retour',
                }
            },
            config: {
                mode: 'ios'
            }

        }, {
            links: [
                { component: TabsPage, name: 'TabsPage', segment: 'tabs-page' },
                { component: SchedulePage, name: 'Schedule', segment: 'schedule' },
                { component: SessionDetailPage, name: 'SessionDetail', segment: 'sessionDetail/:sessionId' },

                { component: ScheduleFilterPage, name: 'ScheduleFilter', segment: 'scheduleFilter' },
                { component: SpeakerListPage, name: 'SpeakerList', segment: 'speakerList' },
                { component: SpeakerDetailPage, name: 'SpeakerDetail', segment: 'speakerDetail/:speakerId' },

                { component: SwitchPage, name: 'SwitchPage', segment: 'rejoindre' },
                { component: AvailabilityPage, name: 'AvailabilityPage', segment: 'availability' },

                { component: MissionsListPage, name: 'MissionsListPage', segment: 'missions' },
                { component: MissionsMapPage, name: 'MissionsMapPage', segment: 'missions' },
                { component: MissionDetailPage, name: 'MissionDetail', segment: 'missions/:missionId' },
                { component: MissionsFilterPage, name: 'MissionsFilterPage', segment: 'missionsFilter' },
                { component: MissionsFilterFormPage, name: 'MissionsFilterFormPage', segment: 'missions' },
                { component: MissionsContractListPage, name: 'MissionsContractListPage', segment: 'my-contracts' },


                { component: MissionsTabsPage, name: 'MissionsTabsPage', segment: 'home' },
                { component: NotificationsPage, name: 'NotificationsPage', segment: 'notifications' },
                { component: MessagingPage, name: 'MessagingPage', segment: 'messaging' },
                { component: MissionsCandidatePage, name: 'MissionsCandidatePage', segment: 'activity' },
                { component: MissionsCandidateDetailPage, name: 'MissionsCandidateDetailPage', segment: 'activity/:missionId' },
                { component: MissionsCalendarPage, name: 'MissionsCalendarPage', segment: 'calendar' },

                { component: HomePage, name: 'HomePage', segment: 'profil' },

                { component: MapPage, name: 'Map', segment: 'map' },
                { component: AboutPage, name: 'About', segment: 'about' },

                { component: TestPage, name: 'Test', segment: 'test' },
                { component: TutorialPage, name: 'Tutorial', segment: 'tutorial' },
                { component: SupportPage, name: 'SupportPage', segment: 'support' },
                { component: LoginPage, name: 'LoginPage', segment: 'login' },
                { component: AccountPage, name: 'AccountPage', segment: 'account' },
                { component: AccountCompletePage, name: 'AccountCompletePage', segment: 'account-complete' },

                { component: AccountTabsPage, name: 'AccountTabsPage', segment: 'infos' },

                { component: IdentityPage, name: 'IdentityPage', segment: 'identity' },
                { component: AddressPage, name: 'AddressPage', segment: 'address' },
                { component: CivilityPage, name: 'CivilityPage', segment: 'civility' },
                { component: CvPage, name: 'CvPage', segment: 'cv' },
                { component: CvTabsPage, name: 'CvTabsPage', segment: 'cv' },
                { component: DocumentsPage, name: 'DocumentsPage', segment: 'documents' },
                { component: SelfRankingPage, name: 'SelfRankingPage', segment: 'ranking' },
                { component: RankingPage, name: 'RankingPage', segment: 'ranking-list' },
                { component: SignupPage, name: 'SignupPage', segment: 'signup' },

                { component: SalariesPage, name: 'SalariesPage', segment: 'home/documents' },
                { component: ContractsPage, name: 'ContractsPage', segment: 'home/documents' },

                { component: CompanyAccessModal, name: 'CompanyAccessModal', segment: 'company-access' },
                { component: DocumentsCompleteModal, name: 'DocumentsCompleteModal', segment: 'documents-complete' },


            ]
        }),

        IonicStorageModule.forRoot(),
        AngularFireModule.initializeApp(firebaseConfig),
        AngularFireDatabaseModule,
        AngularFireAuthModule,
        SignaturePadModule,
        BrMaskerModule,
        DatePickerModule,
    ],
    bootstrap: [IonicApp],
    entryComponents: [
        FaIconComponent,
        Calendar,
        ConferenceApp,
        AboutPage,
        HomePage,
        TestPage,
        AccountPage,
        AccountCompletePage,
        AccountTabsPage,
        AccountSettingsPage,
        MissionsListPage,
        MissionsMapPage,
        MissionDetailPage,
        MissionsFilterPage,
        MissionsFilterFormPage,
        MissionsPostulatePage,
        MissionsSignPage,
        MissionsCandidatePage,
        MissionsCandidateDetailPage,
        MissionsContractListPage,
        MissionsCalendarPage,
        MissionsTabsPage,
        NotificationsPage,
        NotificationsPopover,
        MessagingPage,
        MessagingPopover,
        MissionCandidateDetailPopover,
        IdentityPage,
        AddressPage,
        CivilityPage,
        CvPage,
        CvExperiencesPage,
        CvDiplomasPage,
        CvCertificatesPage,
        CvLanguagesPage,
        CvTabsPage,
        CvAddForm,
        DocumentsPage,
        ContractsPage,
        SalariesPage,
        SelfRankingPage,
        RankingPage,
        JobSelectForm,
        DocumentSelectForm,
        DocumentViewer,
        VideoRecorderForm,
        VideoWizardForm,
        LocationSelectForm,
        LocationViewer,
        Signpad,
        Timesheet,
        LoginPage,
        MapPage,
        PopoverPage,
        SchedulePage,
        ScheduleFilterPage,
        SessionDetailPage,
        SignupPage,
        SpeakerDetailPage,
        SpeakerListPage,
        TabsPage,
        TutorialPage,
        SupportPage,
        SwitchPage,
        AvailabilityPage,
        RibSelect,
        CompanyAccessModal,
        DocumentsCompleteModal
    ],
    providers: [
        { provide: ErrorHandler, useClass: IonicErrorHandler },
        ConferenceData,
        MissionsData,
        UserData,
        UiData,
        JobDataService,
        PortalDataService,
        UploadService,
        InAppBrowser,
        SplashScreen,
        ScreenOrientation,
        Camera,
        MediaCapture,
        AuthService,
        ConnectivityService,
        StatusBar,
        Device,
        AppVersion,
        LogService,
        Geolocation,
        Network,
        Badge,
        File,
        FileTransfer,
        FCM,
        DatePickerModule,

        {provide: ErrorHandler, useClass: IonicErrorHandler}
    ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts